import { useShallow } from 'zustand/react/shallow';
import { useLanguageStore } from '@stores/language.store.js';
import { useQrSummationData } from '@stores/qrSummation.store';
import { useUserStore } from '@stores/user.store.js';

export function useAppProviderFacade() {
  const { user, fetchUser, setUser, setEventAvailable } = useUserStore(
    useShallow((state) => ({
      user: state.user,
      fetchUser: state.fetchUser,
      setUser: state.setUser,
      setEventAvailable: state.setEventAvailable,
    })),
  );

  const { setRequestPath } = useQrSummationData();

  const { setLangLoading, setLangError } = useLanguageStore(
    useShallow((state) => ({
      setLangLoading: state.setLoading,
      setLangError: state.setError,
    })),
  );

  return {
    user,
    fetchUser,
    setUser,
    setEventAvailable,
    setLangLoading,
    setLangError,
    setRequestPath,
  };
}
